module.exports = __webpack_public_path__ + "static/media/logo.09193335.svg";